import GalleryModal from "./gallery_modal";

window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        new GalleryModal({
            type: 'carousel',
            swipeThreshold: 0,
            dragThreshold: 0
        }, '.gallery-modal');
    }, 1);
});

window.GalleryModal = GalleryModal

document.addEventListener('shopify:section:load', function (event) {
    setTimeout(() => {
        new GalleryModal({
            type: 'carousel',
            swipeThreshold: 0,
            dragThreshold: 0
        }, '.gallery-modal');
    }, 1);

    window.GalleryModal = GalleryModal
});